import { render, staticRenderFns } from "./AlimtalkMng.vue?vue&type=template&id=e51844f8&scoped=true"
import script from "./AlimtalkMng.vue?vue&type=script&lang=js"
export * from "./AlimtalkMng.vue?vue&type=script&lang=js"
import style0 from "./AlimtalkMng.vue?vue&type=style&index=0&id=e51844f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51844f8",
  null
  
)

export default component.exports